import Vue from 'vue';
import Router from 'vue-router';
import home from './vue/home.vue';
import orderAdd from './vue/order/add.vue';
import orderCancel from './vue/order/cancel.vue';
import merchantList from './vue/merchant/list.vue';
import organizationList from './vue/organization/list.vue';
import selectorList from './vue/selector/list.vue';
import tagList from './vue/tag/list.vue';
import statusList from './vue/status/list.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', component: home },
    { path: '/addOrder/:merchantToken/:nr/:id', component: orderAdd },
    { path: '/cancelOrder/:merchantToken/:nr/:id', component: orderCancel },
    { path: '/merchant/', component: merchantList },
    { path: '/organization/', component: organizationList },
    { path: '/selector/', component: selectorList },
    { path: '/tag/', component: tagList },
    { path: '/status/', component: statusList },
  ],
});
